let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hyhWi")).then(() => parcelRequire('ieVy8'));